module.exports = __webpack_public_path__ + "img/sass.29e1417b.png";